module.exports = __webpack_public_path__ + "static/media/ic_rec_start.ea17e145.svg";